/**
 * What each mail provider can do from Quantis today. No client APIs here, so
 * the native app gates the same actions by the same table.
 */

export type MailProviderId = 'gmail' | 'microsoft';

export type MailCapabilities = {
  send: boolean;
  drafts: boolean;
  archive: boolean;
  trash: boolean;
  /** Gmail labels, and filing a message to a project, which reads Gmail's raw MIME. */
  labels: boolean;
  fileToProject: boolean;
};

const CAPABILITIES: Record<MailProviderId, MailCapabilities> = {
  gmail: { send: true, drafts: true, archive: true, trash: true, labels: true, fileToProject: true },
  // Writing and organising Outlook mail ship in later phases.
  microsoft: { send: false, drafts: false, archive: false, trash: false, labels: false, fileToProject: false },
};

export function mailCapabilities(provider: MailProviderId): MailCapabilities {
  return CAPABILITIES[provider];
}

export const MAIL_PROVIDER_NAMES: Record<MailProviderId, string> = { gmail: 'Gmail', microsoft: 'Microsoft 365' };
